import React from 'react';
import { Menu } from 'antd';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router';

import { SettingOutlined } from '@ant-design/icons';

import { useManagementStore, useUserState } from '../../../../store';

import './styles.scss';

function getItem(label, key, icon, children, type) {
    return {
        key,
        icon,
        children,
        label,
        type
    };
}
const items = [
    getItem('Dashboard', '/', <span className="tt-dashboard" style={{ fontSize: 18 }} />),
    getItem('Calendar', '/calendar', <span className="tt-calendar" style={{ fontSize: 18 }} />),
    getItem(
        'Statistics',
        '/summary',
        <span className="tt-bar_chart_4_bars" style={{ fontSize: 18 }} />
    ),
    getItem(
        'Equity Curve',
        '/equity-curve',
        <span className="tt-chart_up" style={{ fontSize: 18 }} />
    ),
    getItem('Trades', '/trades', <span className="tt-feed" style={{ fontSize: 18 }} />),
    getItem('TradeBook', '/tradebook', <span className="tt-Trade" style={{ fontSize: 18 }} />),
    getItem('Compare', '/compare', <span className="tt-balance" style={{ fontSize: 18 }} />),
    getItem(
        'Daily Notes',
        '/daily-trade-notes',
        <span className="tt-Daily-Notes" style={{ fontSize: 18 }} />
    )
    // getItem('Daily Trades', '/daily', <span className='tt-calendar-today' style={{ fontSize: 18 }} />)
];

const hiddenMenuKeys = ['/tradebook', '/compare'];
const visibleItems = items.filter((item) => !hiddenMenuKeys.includes(item.key));

const Sidebar = ({ forcedPublicViewId = null, forcedUnassignedViewId = null }) => {
    const navigate = useNavigate();

    const location = useLocation();

    const { publicView } = useManagementStore((state) => state);
    const { getUser } = useUserState();
    const user = getUser();
    const isAdmin = user?.role === 'admin';
    const isAdminActive =
        (location.pathname === '/admin' || location.pathname.startsWith('/admin/')) &&
        !location.pathname.startsWith('/admin/u/');
    const activePublicViewId = forcedPublicViewId || publicView.id;
    const isUnassignedMode = Boolean(forcedUnassignedViewId);
    const isPublicMode = Boolean(activePublicViewId || publicView.isActive);

    const onClick = (e) => {
        if (isUnassignedMode && forcedUnassignedViewId) {
            const basePrefix = `/admin/u/${forcedUnassignedViewId}`;
            const nextPath = e.key === '/' ? basePrefix : `${basePrefix}${e.key}`;
            navigate(nextPath);
        } else if (isPublicMode && activePublicViewId) {
            navigate(`/${activePublicViewId}${e.key}`);
        } else {
            navigate(e.key);
        }
    };

    const getBasePathname = () => {
        if (isUnassignedMode && forcedUnassignedViewId) {
            const basePath = location.pathname.replace(
                new RegExp(`^/admin/u/${forcedUnassignedViewId}`),
                ''
            );
            return basePath === '' ? '/' : basePath;
        }

        if (!isPublicMode || !activePublicViewId) return location.pathname;

        const basePath = location.pathname.replace(new RegExp(`^/${activePublicViewId}`), '');
        return basePath === '' ? '/' : basePath;
    };
    return (
        <>
            <div className="menu-container">
                <Menu
                    onClick={onClick}
                    style={{
                        height: '100%',
                        backgroundColor: '#FFFFFF',
                        color: '#424242',
                        fontSize: '0.875rem',
                        fontWeight: '400',
                        lineHeight: 'normal',
                        border: 'none'
                    }}
                    selectedKeys={[getBasePathname()]}
                    mode="inline"
                    items={visibleItems}
                />

                {/* Separator */}
                {isAdmin && !isPublicMode && (
                    <>
                        <div className="sidebar-separator" style={{ margin: '16px 0' }}>
                            <hr style={{ border: 0, borderTop: '1px solid #eee', margin: 0 }} />
                        </div>
                        <div
                            className={`sidebar-link${isAdminActive ? ' active' : ''}`}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '10px 16px',
                                cursor: 'pointer',
                                fontWeight: 400,
                                fontSize: 14,
                                color: isAdminActive ? '#2962FF' : '#222', // blue if active, default otherwise
                                background: 'transparent',
                                gap: 12,
                                borderRadius: 6
                            }}
                        >
                            <SettingOutlined style={{ fontSize: 14 }} />
                            <a
                                href="/admin"
                                style={{
                                    color: 'inherit',
                                    textDecoration: 'none',
                                    flex: 1
                                }}
                            >
                                Admin Panel
                            </a>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};
Sidebar.propTypes = {
    forcedPublicViewId: PropTypes.string,
    forcedUnassignedViewId: PropTypes.string
};

export default Sidebar;
